import { Injectable } from '@angular/core';
import { RequestMethodsService } from '../commons/request_methods';
import { Constants } from '../commons/constants';

@Injectable()
export class GridDataService {
    constructor(
        private requestMethodService: RequestMethodsService,
        private constants: Constants){

        }

        getGridData(token, assetId, pointId, PointsDatatype, type,locale){
            let API_URL = window.sessionStorage.getItem('isNetCoreUser') === "true" ? this.constants.NETCORE_BASE_URL : this.constants.LEGACY_BASE_URL;
            return this.requestMethodService.get(
                token,
                API_URL,
                this.constants.GET_GRID_DATA,
                {
                    assetid: assetId,
                    pointid: pointId,
                    charttype:PointsDatatype,
                    type: type,
                    locale: locale
                }
            );
        }
    
}


// WEBPACK FOOTER //
// ./src/services/grid-data.service.ts